import { c as _c } from "react/compiler-runtime";
import Countdown from "@/components/distribution-plan-tool/common/Countdown";
import { BlockPickerAdvancedItemBlockLink } from "../advanced/BlockPickerAdvancedItemBlock";
export default function BlockPickerResultHeader(t0) {
  const $ = _c(19);
  const {
    timestamp,
    blocknumber
  } = t0;
  let t1;
  if ($[0] !== blocknumber) {
    t1 = blocknumber.toString();
    $[0] = blocknumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== blocknumber || $[5] !== t2) {
    t3 = <span className="tw-text-base tw-text-lg tw-text-white tw-font-semibold"><BlockPickerAdvancedItemBlockLink block={blocknumber} blockParts={t2} /></span>;
    $[4] = blocknumber;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== timestamp) {
    t4 = new Date(timestamp).toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    });
    $[7] = timestamp;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="tw-mt-0.5 tw-text-iron-300">is the closest predicted block to{" "}{t4}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="sm:tw-flex sm:tw-items-baseline sm:tw-justify-between"><div className="tw-inline-flex tw-items-center tw-space-x-2"><div className="tw-space-x-1">{t3}{t5}</div></div></div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== timestamp) {
    t7 = <div className="tw-mt-1 tw-text-sm tw-text-white tw-font-semibold"><Countdown timestamp={timestamp} /></div>;
    $[14] = timestamp;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="tw-mt-8 tw-pt-6 tw-border-t tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-iron-700">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}